import { ProductVariation } from 'models/productsReferential';
import { FC, useState } from 'react';

import { AssetSelector } from './asset-selector';
import { ProductSubTypeSelector } from './product-subtype-selector';
import { ProductTypeSelector } from './product-type-selector';

export type CatalogProps = {
  products: ReadonlyArray<ProductVariation>;
  onSelectProduct: (product: ProductVariation) => void;
  initialAssetType?: string;
};

export const Catalog: FC<CatalogProps> = ({ products, onSelectProduct, initialAssetType }) => {
  const [selectedAssetType, setSelectedAssetType] = useState<string | undefined>(initialAssetType);
  const [selectedProductType, setSelectedProductType] = useState<string | undefined>(undefined);

  const handleSelectAssetType = (label: string) => {
    setSelectedAssetType(label);
    setSelectedProductType(undefined);
  };

  const handleSelectProductType = (id: string) => {
    setSelectedProductType(id);
  };

  const handleSelectProductSubType = (productType: string, productSubType: string) => {
    const product = products.find(
      p =>
        p.productSubType === productSubType &&
        p.productType === productType &&
        p.assetTypes?.some(assetType => assetType === selectedAssetType),
    );
    if (product) {
      onSelectProduct(product);
    }
  };

  return (
    <div className="container-fluid h-100 p-0" role="group" aria-label="Product catalog">
      <div className="row h-100 m-0">
        <AssetSelector
          products={products}
          selectedAssetType={selectedAssetType}
          onSelectAssetType={handleSelectAssetType}
        />
        <ProductTypeSelector
          products={products}
          selectedAssetType={selectedAssetType}
          selectedProductType={selectedProductType}
          onSelectProductType={handleSelectProductType}
        />
        <ProductSubTypeSelector
          products={products}
          selectedProductType={selectedProductType}
          selectedAssetType={selectedAssetType}
          onSelectProductSubType={handleSelectProductSubType}
        />
      </div>
    </div>
  );
};
